import React from "react"
import Animate, { AnimationTypes } from "../Animate/Animate"
import { useTranslation } from "react-i18next"
import { usePublicContact } from "../../context/usePublicContactContext"

const faqItems = ["label_support_faq_1", "label_support_faq_2", "label_support_faq_3", "label_support_faq_4"] as const

const Support: React.FC = () => {
  const { t } = useTranslation("login")

  const { contact } = usePublicContact()

  return (
    <Animate type={AnimationTypes.fadeIn} duration="1.3s">
      <section id="support" className="py-5 lg:py-24 bg-gradient-to-b from-white to-orange-50/40">
        <div className="max-w-[1280px] mx-auto px-6">
          <div className="text-center mb-12">
            <span className="inline-flex items-center rounded-full bg-red-100 text-red-600 text-xs font-extrabold px-3 py-1 uppercase tracking-wide">
              {t("label_support_badge")}
            </span>

            <h2 className="text-3xl font-black text-slate-900 mt-4 mb-3">{t("label_support_title")}</h2>

            <p className="text-slate-500 max-w-2xl mx-auto">{t("label_support_description")}</p>
          </div>

          <div className="grid gap-6 lg:grid-cols-2">
            <div className="rounded-xl border border-red-100 bg-white shadow-sm p-4 lg:p-6">
              <h3 className="text-xl font-extrabold text-slate-900 mb-6">{t("label_support_faq_title")}</h3>

              <div className="space-y-2">
                {faqItems.map((key) => (
                  <details
                    key={key}
                    className="group rounded-xl border border-orange-100 bg-orange-50/40 px-4 py-3 transition-colors open:bg-white open:border-red-200"
                  >
                    <summary className="cursor-pointer list-none font-semibold text-slate-800 flex items-center justify-between gap-3">
                      <span>{t(`${key}.question`)}</span>
                      <span className="text-red-500 transition-transform group-open:rotate-45">+</span>
                    </summary>

                    <p className="text-sm text-slate-600 mt-3 leading-relaxed">{t(`${key}.answer`)}</p>
                  </details>
                ))}
              </div>
            </div>

            <div className="rounded-xl border border-red-100 bg-white shadow-sm p-4 lg:p-6">
              <h3 className="text-xl font-extrabold text-slate-900 mb-6">{t("label_support_contact_title")}</h3>

              <div className="space-y-2">
                {contact.emailUrl && (
                  <a
                    href={contact.emailUrl}
                    className="block rounded-xl border border-orange-100 bg-orange-50/40 p-4 hover:border-red-200 hover:bg-white transition-colors"
                    data-interaction-description-key="interactionDescriptions:components.landPage.support.link.supportEmailTitle"
                  >
                    <p className="text-xs font-bold uppercase tracking-wide text-red-600">
                      {t("label_support_email_title")}
                    </p>
                    <p className="text-sm text-slate-700 mt-1">{contact.email}</p>
                  </a>
                )}

                {contact.whatsappUrl && (
                  <a
                    href={contact.whatsappUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="block rounded-xl border border-orange-100 bg-orange-50/40 p-4 hover:border-red-200 hover:bg-white transition-colors"
                    data-interaction-description-key="interactionDescriptions:components.landPage.support.link.supportWhatsappTitle"
                  >
                    <p className="text-xs font-bold uppercase tracking-wide text-red-600">
                      {t("label_support_whatsapp_title")}
                    </p>
                    <p className="text-sm text-slate-700 mt-1">{contact.whatsappLabel}</p>
                  </a>
                )}

                <div className="rounded-xl border border-orange-100 bg-orange-50/40 p-4">
                  <p className="text-xs font-bold uppercase tracking-wide text-red-600">
                    {t("label_support_billing_title")}
                  </p>
                  <p className="text-sm text-slate-700 mt-1">{t("label_support_billing_description")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Animate>
  )
}

export default Support
